<template>
  <footer>
    <div class="container w-100">
      <div class="row pb-5 footer-items">
        <div class="col-md-3 left-padding">
          <h2>Contact Us</h2>
          <p>
            Contact our team via:
            <br />
            <br />
            <a href="mailto:Andrew@fridayfs.com">Andrew@fridayfs.com</a>
            <br />
            <a href="tel:01502389559">01502 389559</a>
            <br />
            <br />
            Riverside Business Centre<br />
            Lowestoft<br />
            Suffolk<br />
            NR33 0TQ
          </p>
        </div>
        <div class="col-md-3">
          <h2>Sections</h2>
          <ul>
            <li>
              <router-link class="header-nav-link" to="/our-story/">Our Story</router-link>
            </li>

            <li>
              <router-link class="header-nav-link" to="/mortgage-advice/">Mortgage Advice</router-link>
            </li>

            <li>
              <router-link class="header-nav-link" to="/protection/">Protection</router-link>
            </li>


            <li>
              <router-link class="header-nav-link" to="/contact-us/">Contact Us</router-link>
            </li>

          </ul>
        </div>
        <div id="follow-us" class="col-md-3 mb-5">
          <h2>Follow Us</h2>

          <a href="https://www.facebook.com/FridayFS" target="_blank" rel="nofollow"
            class="social facebook d-block mt-2">
            <div class="d-flex align-items-center flex-start">
              <div class="socials-icons">
                <svg class="icon icon-facebook">
                  <use xlink:href="#icon-facebook"></use>
                </svg>
              </div>
              <div>Friday Financial Services</div>
            </div>
          </a>
          <a href="https://www.instagram.com/fridayfinancial/" target="_blank" rel="nofollow"
            class="social d-block mt-2">
            <div class="d-flex align-items-center flex-start">
              <div class="socials-icons">
                <svg class="icon icon-instagram">
                  <use xlink:href="#icon-instagram"></use>
                </svg>
              </div>
              <div>@fridayfinancial</div>
            </div>
          </a>
          <a href="https://wa.me/+447766800885" target="_blank" rel="nofollow" class="social d-block mt-2">
            <div class="d-flex align-items-center flex-start">
              <div class="socials-icons">
                <svg class="icon icon-whatsapp">
                  <use xlink:href="#icon-whatsapp"></use>
                </svg>
              </div>
              <div>WhatsApp Us</div>
            </div>
          </a>
        </div>
        <div class="col-md-3 footer-last">
          <h2>Legal</h2>
          <ul>
            <li>
              <a class="customer-privacy-notice" href="https://www.quilter.com/important-information/privacy-notices/appointed-representative-privacy-notice/" target="_blank">
                Customer Privacy Notice</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container footer-information">
        <p>
          Friday Financial Services Ltd is an appointed representative of Quilter Financial Services Limited 
          which is authorised and regulated by the Financial Conduct Authority.<br>

          Some Buy to Let mortgages are not regulated by the Financial Conduct Authority.<br>

          The guidance and/or information contained within this website is subject to UK regulatory regime
          and is therefore targeted at consumers based in the UK.<br>

          Friday Financial Services Limited is registered as a Company in England & Wales No. 09437683.
          Registered Office: Riverside Business Centre, Lowestoft, Suffolk, NR33 0TQ
        </p>
      </div>
      <div class="container copyright-container">
        <div class="copyright">
          <span>Copyright {{ copyrightDate }} &copy; Friday
            Financial. All Rights Reserved.</span>
        </div>
        <div class="netmatters-design" @click="showAlert">
          <p>
            <span>Website Design</span> by
            <span>Netmatters</span>
          </p>
        </div>
      </div>
    </div>

  </footer>
</template>

<script>
import Swal from 'sweetalert2'

export default {
  data() {
    return {
      name: "main-footer",
      copyrightDate: "",
    }
  },
  mounted() {
    this.copyrightDate = new Date().getFullYear();
  },
  methods: {
    showAlert() {
      // Use sweetalert2
      Swal.fire({
        title: 'Are you sure?',
        confirmButtonColor: '#f7941d',
        cancelButtonColor: '#404042',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, That's fine",
        text: " You are now departing from the regulatory site of Friday Financial Services. Neither Friday" +
          " Financial Services nor Quilter Financial Planning are responsible for the accuracy of the information contained within the linked site."
      }).then((result) => {
        if (result.isConfirmed) {
          window.open("https://www.netmatters.co.uk");
        }
      })
    },
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue